import { useEffect, useState } from "react";
import { productManager } from "../../data/managers/ProductManager";
import { Station } from "../../data/models/product/ProductModel";
import { useLoading } from "../../data/providers/LoadingProvider";
import { useSnackbar } from "../../data/providers/SnackbarProvider";

export const useStations = () => {
  const [stations, setStations] = useState<Station[]>([]);
  const { showSnackbar, showError } = useSnackbar();
  const { startLoading, stopLoading, loading } = useLoading();

  useEffect(() => {
    refreshStations();
  }, []);

  const refreshStations = async () => {
    try {
      startLoading();
      const resp = await productManager.getAllStations();
      if (!resp) {
        showError("No se pudieron cargar las pantallas");
        return;
      }
      setStations(resp.map((c: any) => new Station(c)));
    } catch (err) {
      showError("Error al obtener pantallas");
    } finally {
      stopLoading();
    }
  };

  const createStation = async (name: string) => {
    try {
      startLoading();
      const newStation: Station = { name };
      const r = await productManager.updateOrCreateStation(newStation);
      if (!r) throw new Error("On create station");
      showSnackbar("Pantalla creada correctamente");
    } catch (err) {
      showError(`No se pudo crear la pantalla. ${err}`);
    } finally {
      await refreshStations();
      stopLoading();
    }
  };

  const deleteStation = async (id: string) => {
    try {
      startLoading();
      const station = stations.find((e) => e.id === id);
      if (!station) throw new Error("Station not found");
      const r = await productManager.deleteStation(station);
      if (!r) throw new Error("On delete station");
      showSnackbar("Pantalla eliminada");
    } catch (err) {
      showError("No se pudo eliminar la pantalla");
    } finally {
      await refreshStations();
      stopLoading();
    }
  };

  return {
    stations,
    createStation,
    deleteStation,
    refreshStations,
    totalStations: stations.length,
    loading,
  };
};
